import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { canEditPetition, Loading, petitionSlugCanonicalRedirect } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassador-onboarding',
		path: '/p/:slug/ambassador-onboarding',
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadorOnboarding" */ './index'), {
			exportName: 'AmbassadorOnboarding',
			fallback: Loading,
		}),
		frame: {
			footer: false,
			header: true,
		},
		restrictedAccess: {
			authOnly: true,
			role: canEditPetition('slug'),
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
